import { useEffect, useState } from 'react';

export const useCountdown = (time) => {
  const countDownDate = new Date(time).getTime();
  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
  const minutes =
    countDown > 0 ? String(Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0') : '00';
  const seconds = countDown > 0 ? String(Math.floor((countDown % (1000 * 60)) / 1000)).padStart(2, '0') : '00';

  return [minutes, seconds];
};
